import { CampaignId } from './domain';

export interface ImportExportWizardState {
    cid?: CampaignId;
    status: ImportExportWizardStatus;
    isVisible: boolean;
    isLocked: boolean;
    wizardMode: ImportExportWizardMode;
}

export enum ImportExportWizardMode {
    IMPORT = 'IMPORT',
    EXPORT = 'EXPORT'
}

export enum ImportExportWizardStatus {
    SAVING = 'SAVING',
    SAVED = 'SAVED'
}
